export const getThemeName = (bodyClassName = '') =>
  bodyClassName
    .split(/\s+/)
    .find(
      className => className !== 'theme-xp' && className.indexOf('theme-') === 0
    )



// WEBPACK FOOTER //
// ./src/core/utils/Theme.js